<!-- <p>production-form works!</p> -->
<!-- <p>printing-form works!</p> -->

<div _ngcontent-agi-c86="" class="container-fluid"><div _ngcontent-agi-c86="" class="row justify-content-center mt-5"><div _ngcontent-agi-c86="" class="col-lg-7">




<div class="card">
    <div class="card-body">
      <div class="ng-star-inserted">
        <div class="row">
          <div class="col-md-12 ng-star-inserted">
            <h5 class="text-center font-bold font-up danger-text">Order Details</h5>
            <form [formGroup]="addPrintingDetailForm" class="ng-untouched ng-pristine ng-valid">
                <div class="row">
                    <div class="col form-group mb-3">
                      <label for="refNo" class="form-label">Ref No</label>
                      <input type="text" formControlName="refNo" id="refNo" class="form-control" readonly />
                    </div>
                    <div class="col form-group mb-3">
                        <label for="poNo" class="form-label">PO No</label>
                        <input type="number" formControlName="poNo" id="poNo" class="form-control" readonly />
    
                    </div>  
                    <!-- <div class="col-auto mt-4">
                      <button type="submit" class="btn btn-outline-info">View Orders</button>
                      
                    </div> -->
                  </div>
              <div class="row">
                <div class="col form-group mb-3">
                  <label class="form-label">Client Name</label>
                  <select class="form-select" formControlName="clientName" required (change)="onClientChange($event.target.value)">
                      <option value="" disabled>Select Client</option>
                      <option *ngFor="let client of clientList" [ngValue]="client.clientName">{{ client.clientName }}</option>
                  </select>
              </div>
                <div class="col form-group mb-3">
                  <label for="jobName" class="form-label">Job Name</label>
                  <select class="form-select" formControlName="jobName" required>
                    <option value="" disabled>Select Job Name</option>
                    <option *ngFor="let job of jobList" [ngValue]="job">{{ job }}</option>
                  </select>
                </div>
                <div class="col form-group mb-3">
                    <label for="orderKgs" class="form-label">Order Quantity</label>
                    <input type="text" formControlName="orderKgs" id="orderKgs"
                        class="form-control" readonly />
                </div>
                </div>





                <h5 class="text-center font-bold font-up danger-text">Shift Information</h5>
                <div class="row">
                  <div class="col-3 col form-group mb-3">
                      <label class="form-label">Shift</label>
                      <select class="form-select" formControlName="shift" required>
                        <option value="" disabled>Select Shift</option>
                        <option  value="A">A</option>
                        <option  value="B">B</option>
                        <option  value="C">C</option>
                        <option  value="A 12">A 12</option>
                        <option  value="B 12">B 12</option>
                      </select>
                    </div>
                    <div class="col-3 col form-group mb-3">
                      <label for="machine" class="form-label">Machine</label>
                      <select class="form-select" formControlName="machine" required>
                        <option value="" disabled>Select Machine</option>
                        <option value="P1-ROTO" selected="">P1-ROTO</option>
                        <option value="P2-ROTO">P2-ROTO</option> 
                        <option value="P3-ROTO">P3-ROTO</option> 
                        <option value="P4-ROTO">P4-ROTO</option> 
                        <option value="P5-ROTO">P5-ROTO</option>
                         <option value="P6-ROTO">P6-ROTO</option>
                      </select>
                    </div>
                    <div class="col-3 col form-group mb-3">
                        <label for="operator" class="form-label">Operator</label>
                        <select class="form-select" formControlName="operator" id="operator" required>
                        <option value="Chandrakan" selected="">Chandrakan</option>
                <option value="ASAMOAH">ASAMOAH</option>
                 <option value="BERTHA">BERTHA</option> 
                 <option value="Brigh">Brigh</option> 
                 <option value="Chandrakan">Chandrakan</option> 
                 <option value="Daniel">Daniel</option> 
                 <option value="Deepak">Deepak</option> 
                 <option value="DEEPAK B">DEEPAK B</option>
                </select>
                    </div>
                    <div class="col-3 col form-group mb-3">
                        <label for="operatingTime" class="form-label">Operating time</label>
                        <input type="text" formControlName="operatingTime" id="operatingTime"
                            class="form-control"/>
                    </div>
                </div>
            <div class="row">
              <div class="col form-group mb-3">
                  <label for="timeFrom" class="form-label">Time From</label>
                  <input type="text" formControlName="timeFrom" id="timeFrom"
                  class="form-control" />
                </div>
                <div class="col form-group mb-3">
                  <label for="timeTo" class="form-label">Time To</label>
                  <input type="text" formControlName="timeTo" id="timeTo"
                  class="form-control"/>
                </div>
                <div class="col form-group mb-3">
                    <label for="mcSpeed" class="form-label">MC Speed</label>
                    <input type="text" formControlName="mcSpeed" id="mcSpeed"
                        class="form-control" />
                </div>
                <div class="col form-group mb-3">
                    <label for="inkGsm" class="form-label">Ink GSM</label>
                    <input type="text" formControlName="inkGsm" id="inkGsm"
                        class="form-control"/>
                </div>
                <div class="col form-group mb-3">
                  <label for="availableTime" class="form-label">Available time</label>
                  <input type="text" formControlName="availableTime" id="availableTime"
                      class="form-control" />
              </div>
            </div>

            <div class="row">
              <div class="col-auto col-lg-12 col-md-6 col-xl-6 offset-md-5">
                <!-- <button type="submit" class="btn btn-outline-success" (click)="viewJob()">Add Ink Data</button> -->
                <button type="submit" class="btn btn-outline-danger" (click)="addPrintingDetail()"  [disabled]="!addPrintingDetailForm.valid">Submit</button>
              </div>
            </div>
                <div class="row">
                <!-- <div class="col-auto col-lg-12 col-md-6 col-xl-6 offset-md-5">
                  <a routerLinkActive="router-link-active" routerLink="/addProd"> <button type="submit" class="btn btn-outline-primary" >Production Output</button></a>
                </div> -->
              </div>
            </form>

            <div *ngIf="formSubmitted" class="row mt-4">
              <div class="col-auto col-lg-12 col-md-6 col-xl-6 offset-md-5">
                <button type="button" class="btn btn-outline-primary" (click)="navigateToAddInk()">Next</button>
              </div>
            </div>
          </div>

          
          <!-- <div class="col-md-6 ng-star-inserted">
            <h5 class="text-center font-bold font-up danger-text">Shift Information</h5>
            <form [formGroup]="addPrintingDetailForm" class="ng-untouched ng-pristine ng-valid">
                <div class="row">
                    <div class="col-3 col form-group mb-3">
                        <label class="form-label">Shift</label>
                        <select class="form-select" formControlName="shift" required>
                          <option value="" disabled>Select Shift</option>
                          <option  value="A">A</option>
                          <option  value="B">B</option>
                          <option  value="C">C</option>
                          <option  value="A 12">A 12</option>
                          <option  value="B 12">B 12</option>
                        </select>
                      </div>
                      <div class="col-3 col form-group mb-3">
                        <label for="machine" class="form-label">Machine</label>
                        <select class="form-select" formControlName="machine" required>
                          <option value="" disabled>Select Machine</option>
                          <option value="P1-ROTO" selected="">P1-ROTO</option>
                          <option value="P2-ROTO">P2-ROTO</option> 
                          <option value="P3-ROTO">P3-ROTO</option> 
                          <option value="P4-ROTO">P4-ROTO</option> 
                          <option value="P5-ROTO">P5-ROTO</option>
                           <option value="P6-ROTO">P6-ROTO</option>
                        </select>
                      </div>
                      <div class="col-3 col form-group mb-3">
                          <label for="operator" class="form-label">Operator</label>
                          <select class="form-select" formControlName="operator" id="operator" required>
                          <option value="Chandrakan" selected="">Chandrakan</option>
                  <option value="ASAMOAH">ASAMOAH</option>
                   <option value="BERTHA">BERTHA</option> 
                   <option value="Brigh">Brigh</option> 
                   <option value="Chandrakan">Chandrakan</option> 
                   <option value="Daniel">Daniel</option> 
                   <option value="Deepak">Deepak</option> 
                   <option value="DEEPAK B">DEEPAK B</option>
                  </select>
                      </div>
                      <div class="col-3 col form-group mb-3">
                          <label for="operatingTime" class="form-label">Operating time</label>
                          <input type="text" formControlName="operatingTime" id="operatingTime"
                              class="form-control"/>
                      </div>
                  </div>
              <div class="row">
                <div class="col form-group mb-3">
                    <label for="timeFrom" class="form-label">Time From</label>
                    <input type="text" formControlName="timeFrom" id="timeFrom"
                    class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                    <label for="timeTo" class="form-label">Time To</label>
                    <input type="text" formControlName="timeTo" id="timeTo"
                    class="form-control"/>
                  </div>
                  <div class="col form-group mb-3">
                      <label for="mcSpeed" class="form-label">MC Speed</label>
                      <input type="text" formControlName="mcSpeed" id="mcSpeed"
                          class="form-control" />
                  </div>
                  <div class="col form-group mb-3">
                      <label for="inkGsm" class="form-label">Ink GSM</label>
                      <input type="text" formControlName="inkGsm" id="inkGsm"
                          class="form-control"/>
                  </div>
                  <div class="col form-group mb-3">
                    <label for="availableTime" class="form-label">Available time</label>
                    <input type="text" formControlName="availableTime" id="availableTime"
                        class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="col-auto col-lg-12 col-md-6 col-xl-6 offset-md-5">
                  <button type="submit" class="btn btn-outline-success" (click)="viewJob()">Add Ink Data</button>
                </div>
              </div>
              
            </form>
          </div> -->
        </div>
      </div>
    </div>
  </div>





  <div class="card mb-4">
    <div class="card-body">
  
      <div class="row">
        <!-- Grid column -->
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h3 class="text-center font-bold font-up danger-text">
                Client Name: {{ ClientName }} <br> Jobname:  {{ JobName }}
              </h3>
            </div>
            <!-- <div class="col-md-2">
              <a  class="btn btn-outline-dark btn-sm active" role="button" aria-pressed="true" (click)="saveAndContinue()">Save &
                Continue</a>
            </div> -->
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <div class="table-responsive">
        <table class="table table-bordered red-border text-center">
          <thead>
            <tr>
              <th>P.O No.</th>
              <th>Ref no</th>
              <th>client name</th>
              <th>job name</th>
              <th>order Quantity</th>

              <th>Shift</th>

              <th>machine</th>
              <th>operator</th>
              <th>operatingTime</th>
              <th>timeFrom</th>
              <th>timeTo</th>
              <th>mcSpeed</th>
              <th>inkGsm</th>
              <th>availableTime</th>
              <!-- <th>Thickness</th>
              <th>GSM</th>
              <th>Wastage %</th>
              <th>Mat_Required</th> -->
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of paginatedMaterialMixEntries; let i = index">
              <td>{{ entry.matArray[0].refNo}}</td>
              <td>{{ entry.matArray[0].poNo}}</td>
              <!-- <td>{{ entry.matArray[0]?.materialMix?.name }}</td> -->
  
              <td>{{ entry.matArray[0].clientName}}</td>
              <td>{{ entry.matArray[0].jobName}}</td>
              <td>{{ entry.matArray[0].orderKgs }}</td>

              <td>{{ entry.matArray[0].shift }}</td>

              <td>{{ entry.matArray[0].machine }}</td>
              <td>{{ entry.matArray[0].operator }}</td>
              <td>{{ entry.matArray[0].operatingTime }}</td>
              <td>{{ entry.matArray[0].timeFrom }}</td>
              <td>{{ entry.matArray[0].timeTo }}</td>
              <td>{{ entry.matArray[0].mcSpeed }}</td>
              <td>{{ entry.matArray[0].inkGsm }}</td>
              <td>{{ entry.matArray[0].availableTime }}</td>
              <!-- <td>{{ entry.matArray[0].thickness }}</td>
              <td>0</td>
              <td>{{ entry.matArray[0].waste }}</td>
              <td>{{ entry.matArray[0].matRequired }}</td> -->
  
              <td>
                <!-- <button type="button" routerLink="#" class="btn btn-outline-success btn-sm" (click)="calculateMatRequired(i)">
                  <i class="feather icon-dollar-sign "></i> Calc MatReq
                </button> -->
                <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteMaterialMix(i)">
                  <i class="feather icon-trash-2 text-danger"></i> Delete
                </button>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>

      <!-- production output button -->
      <!-- <div class="col-auto col-lg-12 col-md-6 col-xl-6 offset-md-10">
        <a routerLinkActive="router-link-active" routerLink="/addProd"> <button type="submit" class="btn btn-outline-primary" >Production Output</button></a>
      </div> -->
      <div class="pagination-container">
        <div class="pagination mt-3 d-flex justify-content-between align-items-center">
          <div>
            <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ materialMixEntries.length }}</p>
          </div>
      
          <div class="d-flex">
            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
              <i class="feather icon-chevrons-left"></i>
            </a>
            <ng-container *ngFor="let page of getNumberRangeMatMix(ceilValue(materialMixEntries.length / itemsPerPage))">
              <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                {{ page }}
              </a>
              <span *ngIf="page < ceil(materialMixEntries.length / itemsPerPage)" class="page-number-space"></span>
            </ng-container>
            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceilValue(materialMixEntries.length / itemsPerPage)}">
  
              <i class="feather icon-chevrons-right"></i>
            </a>
          </div>
        </div>
      </div>
      
    </div>
  </div>






</div>
      
</div>
</div>
  
  <!-- <div class="card mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <h2 class="pt-3 pb-4 text-center font-bold font-up danger-text">Message related to Recipe</h2>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered red-border text-center">
            <thead>
                <tr>
                    <th>P.O No.</th>
                    <th>Material</th>
                    <th>Density</th>
                    <th>if_Order</th>
                    <th>Order+%</th>
                    <th>Thickness</th>
                    <th>GSM</th>
                    <th>Wastage %</th>
                    <th>Mat_Required</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>2023-09-30</th>
                    <td>2023-10-01</td>
                    <td>Nutrifood Ghana Limited/Olam</td>
                    <td>LXM0151 PERK MILK SHORTCAKE 55 GR WRAPPER (BC: 301161)</td>
                    <td>20230930-1</td>
                    <td>LXM0151</td>
                    <td>2310001</td>
                    <td>1,300.00</td>
                    <td>0</td>
                   
                </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div> -->
  